module.exports = __webpack_public_path__ + "static/img/card3.71c8df7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card3.png
// module id = i8HZ
// module chunks = 0